import React from "react";
import DataTable from "../../../components/common/DataTable";
import { TABLE_COLUMNS } from "../constants/logConstants";

/**
 * DataCheckerLogsTable displays Data Checker CloudWatch log streams.
 *
 * @param {Object} props
 * @param {Array} props.logs
 * @param {string} props.filterQuery
 * @returns {JSX.Element}
 */
function DataCheckerLogsTable({ logs, filterQuery }) {
  const displayFilteredLogs = () => {
    if (!logs) return [];
    const regex = new RegExp(filterQuery, "i");
    return logs.filter((obj) => regex.test(Object.values(obj)));
  };

  return <DataTable columns={TABLE_COLUMNS.logStreams} dataRows={displayFilteredLogs()} height={"70vh"} />;
}

export default DataCheckerLogsTable;
